"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyTabsInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Loyalty Tabs",
  },
  {
    name: "tabList",
    type: "list",
    subFields: [
      {
        name: "label",
        type: "string",
        defaultValue: "Tab Label",
      },
      {
        name: "blocks",
        type: "uiBlocks",
        hideFromUI: true,
      },
    ],
    defaultValue: [
      {
        label: "Tab 1",
        blocks: [],
      },
      {
        label: "Tab 2",
        blocks: [],
      },
    ],
  },
  {
    name: "defaultActiveTab",
    type: "number",
    defaultValue: 0,
    helperText: "The tab that is active by default on page load.",
  },
] as const satisfies Inputs;

export const LoyaltyTabsComponent: RegisteredComponent = {
  name: "LoyaltyTabs",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  component: dynamic(async () =>
    withValidation(loyaltyTabsInputs, (await import("./LoyaltyTabs")).LoyaltyTabs, "LoyaltyTabs")
  ),
  inputs: loyaltyTabsInputs,
};
